export default __webpack_public_path__ + "static/media/Seguimiento_4.18ee4d29.svg";